import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import LogRocket from 'logrocket';
import { AppModule } from './app/app.module';
import { ICARE_APP_CONFIG } from './app/services/app-config.service';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

export const overrideEnv = async <T>(env: T): Promise<T> => {
  try {
    // Fetches config from assets at run time instead of build time
    const response = await fetch('/assets/config.json');
    const dynamicEnv: T = await response.json();
    return dynamicEnv;
  } catch (e) { }
  return env;
};

const main = async () => {
  overrideEnv(environment).then((dynamicEnv) => {
    if (dynamicEnv.production) {
      LogRocket.init('to7mbo/intelycareclienthub', {
        network: {
          requestSanitizer: (request) => {
            const body = request.body as any;
            // sanitize the call to partcare.php, section=Provdet as the return has DII
            // sanitize all calls that contain /document as we don't want to record document attributes
            // sanitize all calls that contain /logon as we don't want to record login details or jwts  
            if ((
                request.url?.includes('/pages/partcare.php') &&
                body &&
                typeof body === 'object' &&
                typeof body.get === 'function' &&
                body.get('section') === 'Provdet'
              ) || (request.url?.includes('/document')) || (request.url?.includes('/logon'))) {
                return null; 
              }
              return request;
          },
        },
      });
    }
    platformBrowserDynamic([{ provide: ICARE_APP_CONFIG, useValue: dynamicEnv }])
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  });
};

main();
